module.exports = (__webpack_require__(6154))("./node_modules/@studyportals/datalake-event-tracker/dist/datalake_event_tracker.js");